import { Container } from "./LanguageSwitcherStyles";
import { Typography, FONT_FAMILY, ColorSAP } from "../../ontego-ui";

// Supported UI languages. Kept as a list so the switcher renders N segments
// without hardcoded widths — adding a language is a one-line change here.
const LANGUAGES = ["de", "en", "id"];

export const LanguageSwitcher = (props) => {
  const { i18n, theme, onChangeLanguageClick } = props;

  const isDarkTheme = theme == "dark";
  const defaultTextColor = isDarkTheme
    ? ColorSAP.neutral[100]
    : ColorSAP.neutral[0];
  const activeTextColor = isDarkTheme
    ? ColorSAP.neutral[0]
    : ColorSAP.primary[70];
  const activeBackgroundColor = isDarkTheme
    ? ColorSAP.primary[70]
    : ColorSAP.neutral[0];
  const defaultBackgroundColor = isDarkTheme ? "#FFFFFF" : ColorSAP.primary[70];

  // Width scales with the number of segments so each stays ~35px wide,
  // matching the original 2-segment / 70px sizing.
  const segmentWidthPct = `${100 / LANGUAGES.length}%`;

  return (
    <Container
      style={{
        width: 35 * LANGUAGES.length,
        height: 30,
        border: isDarkTheme
          ? `1px solid ${ColorSAP.primary[70]}`
          : `1px solid ${ColorSAP.neutral[0]}`,
        borderRadius: "6px",
      }}
    >
      {LANGUAGES.map((lang) => {
        const isActive = i18n.language === lang;
        return (
          <div
            key={lang}
            style={{
              width: segmentWidthPct,
              height: "100%",
              background: isActive
                ? activeBackgroundColor
                : defaultBackgroundColor,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
              transition: "0.3s all ease-in-out",
            }}
            onClick={() => onChangeLanguageClick(lang)}
          >
            <Typography
              fontFamily={FONT_FAMILY.PLUS_JAKARTA_SANS_MEDIUM}
              size={12}
              color={isActive ? activeTextColor : defaultTextColor}
              style={{
                fontStyle: isActive && "italic",
                fontWeight: isActive ? 700 : 500,
                lineHeight: "normal",
              }}
            >
              {lang.toUpperCase()}
            </Typography>
          </div>
        );
      })}
    </Container>
  );
};
